import {APP_INITIALIZER, inject, NgModule, provideAppInitializer, provideZoneChangeDetection} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {
    ThemingService,
    MessageToastService,
    MessageBoxService,
    BaseThemingConfig,
    ThemingModule,
} from '@fundamental-ngx/core';
import {DialogService} from '@fundamental-ngx/core/dialog';
import {AppConfigService} from './service/services/misc/app-config/app-config.service';
import {CoreModule} from './core/core.module';
import {OrganizationsModule} from './features/organizations/organizations.module';
import {ServiceModule} from './service/service.module';
import { CloudAutomationDesignerLoadDynamic } from "./extension/cloud-automation-designer/cloud-automation-designer-load-dynamic";
import {EventsViewerLoadDynamic} from "./extension/events/events-viewer-load-dynamic";
import {FrontendConfigService} from "./service/services/misc/frontend-config/frontend-config.service";
import {BrowserAnimationsModule, NoopAnimationsModule} from '@angular/platform-browser/animations';
import { provideTheming, themingInitializer } from '@fundamental-ngx/core/theming';
import {BlueprintDesignerLoadDynamic} from "./extension/blueprint-designer/blueprint-designer-load-dynamic";
import {ProductBlueprintModelerLoadDynamic} from "./extension/product-blueprint-modeler/product-blueprint-modeler-load-dynamic";
import {ContentDensityDirective} from "@fundamental-ngx/core/content-density";

const cssVersion = '1.0.1';
const customThemingConfig = new BaseThemingConfig();
customThemingConfig.changeThemeOnQueryParamChange = false;
customThemingConfig.excludeDefaultThemes = true;
customThemingConfig.defaultTheme = 'atom-dark';
customThemingConfig.customThemes = [
    {
        id: 'atom-dark',
        description: 'Fiori theme with Horizon fonts',
        name: 'Fiori theme with Horizon fonts',
        theming: {
            themingBasePath: 'assets/theming-base/atom-dark/css_variables.css?v=' + cssVersion,
            themePath: 'assets/fundamental-styles-theming/atom-dark.css?v=' + cssVersion,
        }
    },
    {
        id: 'atom-light',
        description: 'Horizon theme with Fiori fonts',
        name: 'Horizon theme with Fiori fonts',
        theming: {
            themingBasePath: 'assets/theming-base/atom-light/css_variables.css?v=' + cssVersion,
            themePath: 'assets/fundamental-styles-theming/atom-light.css?v=' + cssVersion,
        }
    },
    {
        id: 'atom-hcb',
        description: 'Horizon theme with Fiori fonts',
        name: 'Horizon theme with Fiori fonts',
        theming: {
            themingBasePath: 'assets/theming-base/atom-hcb/css_variables.css?v=' + cssVersion,
            themePath: 'assets/fundamental-styles-theming/atom-hcb.css?v=' + cssVersion,
        }
    }
];

@NgModule({
    declarations: [
        AppComponent,
        CloudAutomationDesignerLoadDynamic,
        BlueprintDesignerLoadDynamic,
        EventsViewerLoadDynamic,
        ProductBlueprintModelerLoadDynamic
    ],
    bootstrap: [AppComponent],
    imports: [
        OrganizationsModule,
        CoreModule,
        ServiceModule,
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        ContentDensityDirective,
        ThemingModule.withConfig({defaultTheme: 'atom-dark', changeThemeOnQueryParamChange: false})],
    providers: [
        ThemingService,
        DialogService,
        MessageToastService,
        MessageBoxService,
        {provide: LocationStrategy, useClass: HashLocationStrategy},
        provideAppInitializer(async () => {
            const appConfigService = inject(AppConfigService);
            await appConfigService.load();
        }),
        provideAppInitializer(async () => {
            const frontendConfigService = inject(FrontendConfigService);
            await frontendConfigService.load();
        }),
        provideTheming(customThemingConfig),
        themingInitializer(),
        provideHttpClient(withInterceptorsFromDi()),
        provideZoneChangeDetection({ eventCoalescing: true, runCoalescing: true }),
    ]
})
export class AppModule {
    constructor() {
    }
}
